import type { IconSvgObject } from './types';

const Link06Icon: IconSvgObject = [
  ["path", { d: "M14 13V9C14 8.44772 13.5523 8 13 8H7C6.44772 8 6 8.44772 6 9V20C6 20.5523 6.44772 21 7 21H13C13.5523 21 14 20.5523 14 20V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 11V15C10 15.5523 10.4477 16 11 16H17C17.5523 16 18 15.5523 18 15V4C18 3.44772 17.5523 3 17 3H11C10.4477 3 10 3.44772 10 4V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Link06Icon;
